import { BasketGroupSortType } from 'graphql-api/baskets-api-interfaces';

export function mapSortingByValueColumn(
  sorting: BasketGroupSortType,
  isBasketPlaced: boolean,
): BasketGroupSortType {
  if (sorting === BasketGroupSortType.TotalWsp) {
    return isBasketPlaced ? BasketGroupSortType.TotalNet : sorting;
  }

  return sorting;
}
